import {DateTime} from "luxon";

export default {
  normalDate: (val) => {
    if (!val || isNaN(val)) return null;
    return DateTime.fromMillis(val).toFormat("dd.LL.yyyy");
  }
}
